import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { OverviewPage } from "@/features/overview/overview-page";

export const Route = createFileRoute("/_authenticated/$store/overview")({
  validateSearch: z.object({ range: z.enum(["7d", "30d", "90d"]).optional().catch(undefined) }),
  head: () => ({ meta: [{ title: "Overview · Rogue AI" }] }),
  component: OverviewPage,
});
